import { CookieStorage } from '@aws-amplify/core';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieService } from '@jooxter/storage';

// Wires Amplify's Cognito token provider to the same cookie-backed storage CookieService already
// manages (SameSite/Partitioned options resolved from window.name, see @jooxter/storage /
// @jooxter/utils' getWindowName) — shared by every app/package that authenticates against
// Cognito directly (apps/web, @jooxter/teams-auth), so a future change to this wiring only needs
// to happen once.
export const configureCognitoCookieStorage = (): void => {
  cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage({ ...CookieService.setOptions }));
};
